// extracted by mini-css-extract-plugin
module.exports = {"container":"MXig2M0p2-cKEvrka0ymC","title":"_1B6vvTkMfrvB6r-UkoRBKH","footer":"mUmYgwUuEJZeW78U_jjdq","instruction":"_2leFvxIFEFBf_yNs-J5FeQ"};